import * as React from 'react';
import { useAppointmentContext } from '../context/AppointmentContext.js';
import { usePageData } from '../context/PageDataContext.js';

const useAppointmentTypes = ()=>{
    const pageData = usePageData();
    const [, { store  }] = useAppointmentContext();
    const sortedAppointmentTypes = React.useMemo(()=>{
        var ref;
        const appointmentTypes = (ref = store === null || store === void 0 ? void 0 : store.appointmentTypes) !== null && ref !== void 0 ? ref : [];
        return appointmentTypes.sort((a, b)=>{
            var _appointmentTypes;
            const pageTypes = (_appointmentTypes = pageData.appointmentTypes) !== null && _appointmentTypes !== void 0 ? _appointmentTypes : [];
            const aIndex = pageTypes.findIndex(({ typeId  })=>typeId === a.id
            );
            const bIndex = pageTypes.findIndex(({ typeId  })=>typeId === b.id
            );
            if (aIndex === -1) {
                return 1;
            } else if (bIndex === -1) {
                return -1;
            } else {
                return aIndex - bIndex;
            }
        });
    }, [
        pageData,
        store
    ]);
    var ref3;
    const appointmentTypeIcons = React.useMemo(()=>{
        var ref;
        return (ref3 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.icon !== undefined) {
                acc[entry.typeId] = entry.icon;
            }
            return acc;
        }, {})) !== null && ref3 !== void 0 ? ref3 : {};
    }, [
        pageData
    ]);
    var ref1;
    const appointmentGlobalLabels = React.useMemo(()=>{
        var ref;
        return (ref1 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.globalLabel !== undefined) {
                acc[entry.typeId] = entry.globalLabel;
            }
            return acc;
        }, {})) !== null && ref1 !== void 0 ? ref1 : {};
    }, [
        pageData
    ]);
    var ref2;
    const appointmentTypeToolTips = React.useMemo(()=>{
        var ref;
        return (ref2 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.typeDetails !== undefined) {
                acc[entry.typeId] = entry.typeDetails;
            }
            return acc;
        }, {})) !== null && ref2 !== void 0 ? ref2 : {};
    }, [
        pageData
    ]);
    return React.useMemo(()=>({
            sortedAppointmentTypes,
            appointmentTypeIcons,
            appointmentGlobalLabels,
            appointmentTypeToolTips
        })
    , [
        sortedAppointmentTypes,
        appointmentTypeIcons,
        appointmentGlobalLabels,
        appointmentTypeToolTips
    ]);
};

export { useAppointmentTypes as default, useAppointmentTypes };
//# sourceMappingURL=use-appointment-types.js.map
